import Dashboard from '@/pages/Dashboard';

// Portal-scoped dashboard — renders the same Dashboard component
// but within the portal context (PortalLayout provides the context)
const PortalDashboard = () => <Dashboard />;

export default PortalDashboard;
